@if (!loading && !error && overviewData) {
<div class="education-overview-container">

  <!-- Top Row: Score Widget and Chart -->
  <div class="top-row">
    <!-- Composite Score Widget -->
    <div class="score-widget">
      <h3>Composite Score</h3>
      <div class="gauge-container">
        <div class="score-gauge">
          <div class="gauge-circle"
            [style.background]="'conic-gradient(' + getScoreColor(overviewData.composite_score.value) + ' 0deg ' + (overviewData.composite_score.value * 3.6) + 'deg, #e0e0e0 ' + (overviewData.composite_score.value * 3.6) + 'deg 360deg)'">
            <div class="gauge-inner">
              <span class="score-value">{{ overviewData.composite_score.value }}</span>
              <span class="score-label">{{ overviewData.composite_score.label }}</span>
            </div>
          </div>
        </div>
        <div class="brand-name">{{ overviewData.composite_score.brand }}</div>
      </div>
    </div>

    <!-- Competitor Analysis Chart -->
    @if (overviewData) {
      <app-combo-chart [competitorAnalysisData]="overviewData.competitor_analysis"
        [xAxisLabel]="'Educational Properties'" [yAxisLabel]="overviewData.competitor_analysis.y_axis"
        [legendTitle]="'Competitors'" [showGridLines]="true" [animations]="true" [view]="[800, 400]">
      </app-combo-chart>
    }
  </div>

  <!-- Performance Table -->
  <div class="performance-table">
    <h3>Overall Performance</h3>
    <div class="table-container">
      <table class="performance-table">
        <thead>
          <tr>
            <th>University</th>
            <th>Teaching Quality</th>
            <th>Academic Reputation</th>
            <th>Placement Rate</th>
            <th>International Outlook</th>
            <th>Resources & Infrastructure</th>
            <th>Industry & Knowledge Transfer</th>
            <th>Fees</th>
            <th>Rankings</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of overviewData.performance_table" [class.your-brand]="row.is_your_brand">
            <td class="university-name">
              {{ row.university }}
              <span *ngIf="row.is_your_brand" class="your-brand-badge">YOU</span>
            </td>
            <td [style.color]="getScoreColor(row.teaching_quality)">{{ row.teaching_quality }}</td>
            <td [style.color]="getScoreColor(row.academic_reputation)">{{ row.academic_reputation }}</td>
            <td [style.color]="getScoreColor(row.placement_rate)">{{ row.placement_rate }}</td>
            <td [style.color]="getScoreColor(row.international_outlook)">{{ row.international_outlook }}</td>
            <td [style.color]="getScoreColor(row.resources_infrastructure)">{{ row.resources_infrastructure }}</td>
            <td [style.color]="getScoreColor(row.industry_knowledge_transfer)">{{ row.industry_knowledge_transfer }}</td>
            <td class="fees">{{ row.fees }}</td>
            <td class="rankings">{{ row.rankings }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- References & Methodology -->
  <div class="methodology-section">
    <h3>References & Methodologies</h3>
    <div class="methodology-content">
      <div [innerHTML]="overviewData.references.methodology"></div>

      <h4>Sources:</h4>
      <ul>
        <li *ngFor="let source of overviewData.references.sources">
          <a [href]="source.url" target="_blank">{{ source.title }}</a>
          <span class="confidence">({{ source.confidence }}% confidence)</span>
        </li>
      </ul>

      <p class="last-updated">
        Last updated: {{ overviewData.references.last_updated | date:'medium' }}
      </p>
    </div>
  </div>

</div>
}

<!-- Loading State -->
<div class="loading-container" *ngIf="loading">
  <mat-spinner></mat-spinner>
  <p>Loading overview data...</p>
</div>

<!-- Error State -->
<div class="error-container" *ngIf="error">
  <mat-icon>error</mat-icon>
  <p>{{ error }}</p>
  <button mat-raised-button color="primary" (click)="retryLoad()">
    Retry
  </button>
</div>
